import { AmplifyImpactInfoEvents } from '../models/amplifyImpactInfoEvents'

// WidgetAmplifyImpactInfo from mf-amplify-impact requests the editor over the same bus
export const AMPLIFY_IMPACT_INFO_EVENT_BUS = 'amplifyImpactInfoEventBus'

export const AMPLIFY_IMPACT_INFO_EVENTS = [
  AmplifyImpactInfoEvents.keyInitiativeEditorRequested,
  AmplifyImpactInfoEvents.keyInitiativeEditorLoadingChanged,
]
